type StepStatuses = {
  0: boolean;
  1: boolean;
  2: boolean;
  3: boolean;
  4: boolean;
};

export const checkStepStatus = (user): StepStatuses => ({
  0: !!user,
  1: !!user?.has_avatar,
  2: !!user?.milestones?.includes('visited_default_pack'),
  3: !!user?.milestones?.includes('created_first_four_assets'),
  4: user?.verified,
});

export const getTodosProgress = (stepStatuses: StepStatuses): number => (
  100 / 5 * Object.values(stepStatuses).reduce((a, item) => a + +item, 0)
);
